module.exports = __webpack_public_path__ + "static/media/bursts_13.4d459818.svg";